(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-seasonal-brand-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const autoplayDuration = 4000;
    const focusAutoplayDuration = 7000;

    const initializeFocusCarousels = (scope) => {
      scope.querySelectorAll('[data-tzd-focus-carousel]').forEach((root) => {
        if (root.dataset.tzdFocusReady === 'true') return;
        const slides = Array.from(root.querySelectorAll('[data-tzd-focus-slide]'));
        const metaSlides = Array.from(root.querySelectorAll('[data-tzd-focus-meta]'));
        const controls = Array.from(root.querySelectorAll('[data-tzd-focus-control]'));
        if (slides.length === 0 || slides.length !== controls.length) return;

        root.dataset.tzdFocusReady = 'true';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const controller = new AbortController();
        const signal = controller.signal;
        let activeIndex = 0;
        let timer = 0;

        const clearAutoplay = () => {
          window.clearTimeout(timer);
          timer = 0;
        };

        const activate = (requestedIndex) => {
          activeIndex = (requestedIndex + slides.length) % slides.length;
          slides.forEach((slide, index) => {
            const selected = index === activeIndex;
            const video = slide.querySelector('video');
            slide.classList.toggle('is-active', selected);
            slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
            slide.setAttribute('tabindex', selected ? '0' : '-1');
            if (!video) return;
            if (selected && !reduceMotion && !document.hidden) {
              try { video.currentTime = 0; } catch (error) {}
              const playback = video.play();
              if (playback && typeof playback.catch === 'function') playback.catch(() => {});
            } else {
              video.pause();
            }
          });

          metaSlides.forEach((meta, index) => {
            const selected = index === activeIndex;
            meta.classList.toggle('is-active', selected);
            meta.hidden = !selected;
          });

          controls.forEach((control, index) => {
            const selected = index === activeIndex;
            control.classList.toggle('is-active', selected);
            control.setAttribute('aria-pressed', selected ? 'true' : 'false');
            if (!selected) return;
            const progress = control.querySelector('span');
            if (!progress) return;
            progress.style.animation = 'none';
            void progress.offsetWidth;
            progress.style.animation = '';
          });
        };

        const scheduleAutoplay = () => {
          clearAutoplay();
          if (reduceMotion || document.hidden || slides.length < 2) return;
          timer = window.setTimeout(() => {
            activate(activeIndex + 1);
            scheduleAutoplay();
          }, focusAutoplayDuration);
        };

        controls.forEach((control) => {
          control.addEventListener('click', () => {
            activate(Number(control.dataset.index));
            scheduleAutoplay();
          }, { signal });
        });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            clearAutoplay();
            slides.forEach((slide) => {
              const video = slide.querySelector('video');
              if (video) video.pause();
            });
            return;
          }
          activate(activeIndex);
          scheduleAutoplay();
        }, { signal });

        activate(0);
        scheduleAutoplay();

        root.tzdFocusCleanup = () => {
          clearAutoplay();
          controller.abort();
          slides.forEach((slide) => {
            const video = slide.querySelector('video');
            if (video) video.pause();
          });
          root.removeAttribute('data-tzd-focus-ready');
          delete root.tzdFocusCleanup;
        };
      });
    };

    const initialize = (scope) => {
      initializeFocusCarousels(scope);
      scope.querySelectorAll('[data-tzd-system-tabs]').forEach((root) => {
        if (root.dataset.tzdTabsReady === 'true') return;
        const tabs = Array.from(root.querySelectorAll('[data-tzd-system-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-tzd-system-panel]'));
        const tablist = root.querySelector('[role="tablist"]');
        if (tabs.length === 0 || !tablist) return;

        root.dataset.tzdTabsReady = 'true';
        root.classList.add('is-tabs-enhanced');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const controller = new AbortController();
        const signal = controller.signal;
        let timer = 0;
        let isUserPaused = false;

        const clearAutoplay = () => {
          window.clearTimeout(timer);
          timer = 0;
        };

        const centerTab = (tab, behavior) => {
          const maxScroll = Math.max(0, tablist.scrollWidth - tablist.clientWidth);
          if (maxScroll === 0) return;
          const listRect = tablist.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          const target = tablist.scrollLeft + tabRect.left - listRect.left - (tablist.clientWidth - tabRect.width) / 2;
          tablist.scrollTo({
            left: Math.max(0, Math.min(maxScroll, target)),
            behavior
          });
        };

        const autoplayIsPaused = () => (
          reduceMotion
          || tabs.length < 2
          || isUserPaused
          || document.hidden
        );

        let scheduleAutoplay;

        const activate = (tab, moveFocus, restartAutoplay) => {
          const panelId = tab.getAttribute('aria-controls');
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.setAttribute('tabindex', selected ? '0' : '-1');
          });
          panels.forEach((panel) => {
            const selected = panel.id === panelId;
            panel.classList.toggle('is-active', selected);
            panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
            const link = panel.querySelector('a');
            if (link) link.setAttribute('tabindex', selected ? '0' : '-1');
          });
          centerTab(tab, reduceMotion ? 'auto' : 'smooth');
          if (moveFocus) tab.focus({ preventScroll: true });
          if (restartAutoplay) scheduleAutoplay();
        };

        scheduleAutoplay = () => {
          clearAutoplay();
          tabs.forEach((tab) => tab.classList.remove('is-progressing'));
          const paused = autoplayIsPaused();
          root.classList.toggle('is-autoplay-paused', paused);
          if (paused) return;

          const activeTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
          void activeTab.offsetWidth;
          activeTab.classList.add('is-progressing');
          timer = window.setTimeout(() => {
            const currentIndex = tabs.indexOf(activeTab);
            const nextTab = tabs[(currentIndex + 1) % tabs.length];
            activate(nextTab, false, false);
            scheduleAutoplay();
          }, autoplayDuration);
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            isUserPaused = true;
            activate(tab, false, true);
          }, { signal });
          tab.addEventListener('keydown', (event) => {
            let nextIndex = index;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (nextIndex === index) return;
            event.preventDefault();
            isUserPaused = true;
            activate(tabs[nextIndex], true, true);
          }, { signal });
        });

        document.addEventListener('visibilitychange', scheduleAutoplay, { signal });
        scheduleAutoplay();

        root.tzdTabsCleanup = () => {
          clearAutoplay();
          controller.abort();
          root.classList.remove('is-tabs-enhanced', 'is-autoplay-paused');
          root.removeAttribute('data-tzd-tabs-ready');
          delete root.tzdTabsCleanup;
        };
      });
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-tzd-focus-carousel]').forEach((root) => {
        if (root.tzdFocusCleanup) root.tzdFocusCleanup();
      });
      event.target.querySelectorAll('[data-tzd-system-tabs]').forEach((root) => {
        if (root.tzdTabsCleanup) root.tzdTabsCleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss26-golf-confidence-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const openedItem = event.target;
    if (!openedItem.matches('.ss26-golf-faq__item') || !openedItem.open) return;

    const list = openedItem.closest('.ss26-golf-faq__list');
    if (!list) return;
    list.querySelectorAll('.ss26-golf-faq__item[open]').forEach((item) => {
      if (item !== openedItem) item.open = false;
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss26-golf-gift-promotion"]) return;
  try {
    
  document.querySelectorAll('[data-ss26-gift-promotion-source]').forEach((source) => {
    if (source.dataset.initialized === 'true') return;
    source.dataset.initialized = 'true';

    const endAt = source.dataset.campaignEndAt;
    if (endAt && Date.now() > Date.parse(endAt)) {
      source.remove();
      return;
    }

    const offer = source.querySelector('[data-ss26-gift-offer]');
    const blocks = document.querySelector('.product-single__meta [data-product-blocks]');
    const buyBlock = Array.from(blocks?.children || []).find((block) =>
      block.querySelector('form[action*="/cart/add"]')
    );

    if (offer && buyBlock) {
      buyBlock.after(offer);
      source.remove();
    } else {
      source.hidden = false;
    }

    offer?.addEventListener('toggle', () => {
      if (!offer.open || !Array.isArray(window.dataLayer)) return;
      window.dataLayer.push({ event: 'ss26_gift_offer_open' });
    });

    offer?.addEventListener('click', (event) => {
      const tier = event.target.closest('[data-ss26-gift-tier]');
      const collectionCta = event.target.closest('[data-ss26-gift-collection-cta]');
      if (!tier && !collectionCta) return;
      if (!Array.isArray(window.dataLayer)) return;
      window.dataLayer.push({
        event: 'ss26_gift_cta_click',
        gift_tier: tier?.dataset.ss26GiftTier || 'collection'
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss26-golf-pdp-tuning"]) return;
  try {
    
  document.querySelectorAll('[data-ss26-golf-pdp-source]').forEach((source) => {
    if (source.dataset.initialized === 'true') return;

    const meta = document.querySelector('.product-single__meta');
    const blocks = meta?.querySelector('[data-product-blocks]');
    const header = meta?.querySelector('.product-block--header');
    const price = blocks?.querySelector(':scope > .product-block--price');

    if (!meta || !blocks || !header || !price || meta.dataset.ss26Enhanced === 'true') return;

    source.dataset.initialized = 'true';
    meta.dataset.ss26Enhanced = 'true';

    const kicker = source.querySelector('[data-ss26-pdp-kicker]');
    const subheading = source.querySelector('[data-ss26-pdp-subheading]');
    const fit = source.querySelector('[data-ss26-pdp-fit]');
    const returnItem = source.querySelector('[data-ss26-pdp-return]');
    const mediaCount = source.querySelector('[data-ss26-media-count]');
    const fathersDayDiscount = source.querySelector('[data-ss26-fathers-day-discount]');
    const fathersDayPricing = source.querySelector('[data-ss26-fathers-day-pricing]');

    document.documentElement.style.setProperty(
      '--ss26-pdp-media-ratio',
      source.dataset.mobileMediaRatio || '3 / 4'
    );

    const title = header.querySelector('.product-single__title');
    if (title && source.dataset.displayTitle) title.textContent = source.dataset.displayTitle;

    if (kicker) header.before(kicker);

    const titleRow = document.createElement('div');
    titleRow.className = 'ss26-golf-pdp-title-row';
    header.before(titleRow);
    titleRow.append(header, price);

    if (fathersDayPricing) {
      price.classList.add('ss26-fathers-day-price-active');
      price.append(fathersDayPricing);

      let eligibleVariantIds = new Set();
      const variantJson = meta.querySelector('[data-variant-json]');
      if (variantJson) {
        try {
          eligibleVariantIds = new Set(
            JSON.parse(variantJson.textContent || '[]').map((variant) => String(variant.id))
          );
        } catch (error) {
          eligibleVariantIds = new Set();
        }
      }

      const formatMoney = (cents) => {
        if (window.theme?.Currency?.formatMoney && window.theme?.settings?.moneyFormat) {
          return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
        }

        return new Intl.NumberFormat('zh-TW', {
          style: 'currency',
          currency: 'TWD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      };

      const updateFathersDayPrice = (variant) => {
        if (!variant || (eligibleVariantIds.size && !eligibleVariantIds.has(String(variant.id)))) return;

        const originalPrice = Number(variant.price);
        if (!Number.isFinite(originalPrice)) return;

        const discountedPrice = Math.round(originalPrice * 0.88);
        const discountedPriceElement = fathersDayPricing.querySelector('[data-ss26-fathers-day-price]');
        const originalPriceElement = fathersDayPricing.querySelector('[data-ss26-fathers-day-original-price]');

        if (discountedPriceElement) discountedPriceElement.textContent = formatMoney(discountedPrice);
        if (originalPriceElement) originalPriceElement.textContent = formatMoney(originalPrice);
      };

      document.addEventListener('variant:change', (event) => {
        updateFathersDayPrice(event.detail?.variant);
      });
    }

    if (fathersDayDiscount) titleRow.after(fathersDayDiscount);
    if (subheading) (fathersDayDiscount || titleRow).after(subheading);

    const salesPoints = Array.from(blocks.children).filter((block) =>
      block.classList.contains('product-block--sales-point')
    );
    const benefitPoints = salesPoints.slice(0, 3);
    const servicePoints = salesPoints.slice(3);
    const variantBlock = Array.from(blocks.children).find((block) =>
      block.hasAttribute('data-dynamic-variants-enabled')
    );

    if (benefitPoints.length && variantBlock) {
      const proofGrid = document.createElement('div');
      proofGrid.className = 'ss26-golf-pdp-proof-grid';
      variantBlock.before(proofGrid);
      benefitPoints.forEach((point) => proofGrid.append(point));
    }

    const sizeWrapper = Array.from(meta.querySelectorAll('.variant-wrapper')).find((wrapper) => {
      const label = wrapper.querySelector('.variant__label')?.textContent || '';
      return /尺寸|size/i.test(label);
    });

    if (fit && variantBlock && sizeWrapper) {
      fit.hidden = false;
      variantBlock.after(fit);

      fit.querySelector('[data-ss26-size-guide]')?.addEventListener('click', () => {
        const sizeTrigger = Array.from(meta.querySelectorAll('.collapsible-trigger')).find((trigger) =>
          /尺寸/.test(trigger.textContent || '')
        );
        if (!sizeTrigger) return;
        if (sizeTrigger.getAttribute('aria-expanded') !== 'true') sizeTrigger.click();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sizeTrigger.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }

    const dispatchPoint = servicePoints.find((point) => /出貨|工作天/.test(point.textContent || ''));
    const shippingPoint = servicePoints.find((point) => point !== dispatchPoint);
    const trustGrid = document.createElement('div');
    trustGrid.className = 'ss26-golf-pdp-trust-grid';
    if (dispatchPoint) trustGrid.append(dispatchPoint);
    if (returnItem) trustGrid.append(returnItem);

    const fitAnchor = fit && !fit.hidden ? fit : variantBlock;
    if (trustGrid.children.length && fitAnchor) fitAnchor.after(trustGrid);

    if (shippingPoint) {
      shippingPoint.classList.add('ss26-golf-pdp-shipping-note');
      trustGrid.after(shippingPoint);
    }

    const buyBlock = Array.from(blocks.children).find((block) =>
      block.querySelector('form[action*="/cart/add"]')
    );
    const purchaseAnchor = shippingPoint || (trustGrid.children.length ? trustGrid : fitAnchor);
    if (buyBlock && purchaseAnchor) purchaseAnchor.after(buyBlock);

    const gallery = document.querySelector('.product__main-photos');
    const slides = gallery ? Array.from(gallery.querySelectorAll('.product-main-slide')) : [];
    if (gallery && mediaCount && slides.length) {
      gallery.append(mediaCount);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const videoSlides = slides.filter((slide) => slide.querySelector('.product__video-wrapper'));

      videoSlides.forEach((slide) => {
        slide.classList.add('ss26-golf-video-slide');
        const video = slide.querySelector('.product__video-wrapper video');
        if (!video) return;
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');
      });

      const videoThumbs = videoSlides
        .map((slide) => {
          const mediaId = slide.dataset.mediaId;
          const thumb = mediaId ? document.querySelector(`[data-product-thumb][data-id="${mediaId}"]`) : null;
          return thumb ? { thumb, slide } : null;
        })
        .filter(Boolean);

      videoThumbs.forEach(({ thumb, slide }) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          thumb.blur();
          thumb.focus({ preventScroll: true });

          const video = slide.querySelector('.product__video-wrapper video');
          if (!video || reducedMotion.matches) return;
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        });
      });

      let initialIndex = 0;
      let counterReady = false;
      const updateMediaCount = () => {
        if (!counterReady) {
          mediaCount.textContent = `1 / ${slides.length}`;
          return;
        }
        const selected = slides.find((slide) => slide.classList.contains('is-selected')) || slides[0];
        const selectedIndex = ((slides.indexOf(selected) - initialIndex + slides.length) % slides.length) + 1;
        mediaCount.textContent = `${selectedIndex} / ${slides.length}`;
      };

      const syncActiveVideo = () => {
        videoSlides.forEach((slide) => {
          const video = slide.querySelector('.product__video-wrapper video');
          if (!video) return;

          if (slide.classList.contains('is-selected') && !reducedMotion.matches && !document.hidden) {
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      };

      const updateGalleryState = () => {
        updateMediaCount();
        window.requestAnimationFrame(syncActiveVideo);
      };

      updateGalleryState();
      const mediaObserver = new MutationObserver(updateGalleryState);
      slides.forEach((slide) => mediaObserver.observe(slide, { attributes: true, attributeFilter: ['class'] }));
      document.addEventListener('visibilitychange', syncActiveVideo);
      reducedMotion.addEventListener('change', syncActiveVideo);
      window.setTimeout(() => {
        const settledSlide = slides.find((slide) => slide.classList.contains('is-selected')) || slides[0];
        initialIndex = slides.indexOf(settledSlide);
        counterReady = true;
        updateGalleryState();
      }, 500);
    }
  });

  const hideInfiniteSliderClonesFromAssistiveTech = () => {
    document.querySelectorAll('[class*="ai-infinite-slider-track-"]').forEach((track) => {
      const originalCards = new Set();

      Array.from(track.children).forEach((card) => {
        const title = card.querySelector('h1, h2, h3, h4, h5, h6')?.textContent?.trim() || '';
        const image = card.querySelector('img')?.currentSrc || card.querySelector('img')?.src || '';
        const key = `${title}|${image}`;

        if (!title && !image) return;

        track.setAttribute('role', 'list');

        if (!originalCards.has(key)) {
          originalCards.add(key);
          card.removeAttribute('aria-hidden');
          card.removeAttribute('inert');
          card.setAttribute('role', 'listitem');
          return;
        }

        card.setAttribute('aria-hidden', 'true');
        card.setAttribute('role', 'presentation');
        card.setAttribute('inert', '');
        card.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((control) => {
          control.setAttribute('tabindex', '-1');
          control.setAttribute('aria-hidden', 'true');
        });
      });
    });
  };

  const scheduleInfiniteSliderAccessibilitySync = () => {
    hideInfiniteSliderClonesFromAssistiveTech();
    window.setTimeout(hideInfiniteSliderClonesFromAssistiveTech, 500);
    window.setTimeout(hideInfiniteSliderClonesFromAssistiveTech, 1500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInfiniteSliderAccessibilitySync, { once: true });
  } else {
    scheduleInfiniteSliderAccessibilitySync();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss26-golf-sticky-purchase"]) return;
  try {
    
  if (!customElements.get('ss26-golf-sticky-atc')) {
    customElements.define(
      'ss26-golf-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-sticky-button]');
          this.selection = this.querySelector('[data-sticky-selection]');
          this.price = this.querySelector('[data-sticky-price]');
          this.meta = document.querySelector('.product-single__meta');
          this.form = this.meta?.querySelector('form[action*="/cart/add"]');
          this.originalButton = this.form?.querySelector('button[name="add"], button[type="submit"]');
          this.priceSource = this.meta?.querySelector('[data-product-price]');
          this.hasSize = this.dataset.hasSize === 'true';
          this.directAdd = this.dataset.directAdd === 'true';

          this.sizeWrapper = Array.from(this.meta?.querySelectorAll('.variant-wrapper') || []).find((wrapper) => {
            const label = wrapper.querySelector('.variant__label')?.textContent || '';
            return /尺寸|size/i.test(label);
          });
          this.optionTarget = this.sizeWrapper || this.meta?.querySelector('.variant-wrapper.js, .variant-input-wrap');

          if (!this.button || !this.form || !this.originalButton) return;

          this.button.addEventListener('click', () => this.handleClick());
          this.meta.addEventListener('change', (event) => this.handleOptionChange(event));

          if ('MutationObserver' in window) {
            if (this.priceSource) {
              this.priceObserver = new MutationObserver(() => this.updateUI());
              this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
            }
            this.buttonObserver = new MutationObserver(() => this.updateUI());
            this.buttonObserver.observe(this.originalButton, {
              attributes: true,
              attributeFilter: ['disabled', 'aria-disabled', 'class']
            });
          }

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
              this.setVisible(!entries[0].isIntersecting);
            });
            this.observer.observe(this.originalButton);
          } else {
            this.setVisible(true);
          }

          this.updateUI();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.priceObserver?.disconnect();
          this.buttonObserver?.disconnect();
          this.setVisible(false);
        }

        setVisible(visible) {
          this.classList.toggle('is-visible', visible);
          document.body?.classList.toggle('ss26-sticky-atc-visible', visible);
        }

        handleOptionChange(event) {
          const changedWrapper = event.target.closest('.variant-wrapper');
          if (!changedWrapper) return;

          window.setTimeout(() => this.updateUI(), 50);
        }

        updateUI() {
          const unavailable =
            this.dataset.available !== 'true' ||
            this.originalButton?.matches('[disabled], [aria-disabled="true"], .disabled');
          const selectedSize = this.sizeWrapper?.querySelector('input:checked')?.value;
          const selectedOption = this.optionTarget?.querySelector('input:checked')?.value;

          if (this.priceSource && this.price) {
            this.price.textContent = this.priceSource.textContent.trim();
          }

          if (unavailable) {
            this.button.disabled = true;
            this.button.textContent = this.dataset.soldLabel;
            return;
          }

          this.button.disabled = false;

          if (this.directAdd) {
            this.selection.textContent = '可直接加入購物車';
            this.button.textContent = this.dataset.addLabel;
            return;
          }

          if (this.hasSize) {
            this.selection.textContent = selectedSize ? `已選 ${selectedSize}` : '請選擇尺寸';
            this.button.textContent = selectedSize ? this.dataset.addLabel : this.dataset.sizeLabel;
            return;
          }

          this.selection.textContent = selectedOption ? `已選 ${selectedOption}` : '請選擇款式';
          this.button.textContent = selectedOption ? this.dataset.addLabel : this.dataset.optionLabel;
        }

        handleClick() {
          if (
            this.dataset.available !== 'true' ||
            this.originalButton.matches('[disabled], [aria-disabled="true"], .disabled')
          ) return;

          const selectedSize = this.sizeWrapper?.querySelector('input:checked')?.value;
          const selectedOption = this.optionTarget?.querySelector('input:checked')?.value;
          const hasResolvedSelection = this.directAdd || (this.hasSize ? selectedSize : selectedOption);

          if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
              event: 'ss26_sticky_atc_click',
              product_handle: this.dataset.productHandle,
              selection_required: !hasResolvedSelection
            });
          }

          if (hasResolvedSelection) {
            this.originalButton.click();
            return;
          }

          const target = this.optionTarget || this.originalButton;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });

          const focusable =
            target.querySelector?.('button:not([disabled]), input:not([disabled]), select:not([disabled])') || target;
          focusable.focus?.({ preventScroll: true });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
